import { Tag as _Tag } from 'antd'
import styled from 'styled-components'

const StyledTag = styled(_Tag)`
  display: block;
  margin-bottom: 8px;
  cursor: pointer;
`

/**
 * Component
 */

interface Props {
  tag: string
  isAssigned: boolean
  onSaveTag: (tag: string) => void
}

export const Tag = ({ tag, isAssigned, onSaveTag }: Props) => {
  const formattedTag = tag.toUpperCase()
  return (
    <StyledTag
      color={isAssigned ? '#37BBFF' : ''}
      onClick={() => onSaveTag(tag)}
    >
      {formattedTag}
    </StyledTag>
  )
}
